import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const ExclamationErrorIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='64'
    height='64'
    viewBox='0 0 64 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='64' height='64' rx='32' fill='#450A0A' />
    <rect
      x='8.5'
      y='8.5'
      width='47'
      height='47'
      rx='23.5'
      stroke='white'
      stroke-opacity='0.2'
    />
    <path
      d='M34 34L30 34L30 22L34 22L34 34ZM34 42L30 42L30 38L34 38L34 42Z'
      fill='#F87171'
    />
  </svg>
);

export default ExclamationErrorIcon;
